import React from "react";
import Header from "../components/Header";
import Slider from "../components/Slider";
import BannerHome from "../components/BannerHome";
import DoctorTestimonials from "../components/DoctorTestimonials";
import Slogan from "../components/Slogan";
import Footer from "../components/Footer"; 

export default function Home() {
  return (
    <main style={{ fontFamily: "Inter, Roboto, sans-serif", color: "#222", background: "#fff" }}>
      <Header />
      <Slider />
      <BannerHome />
      <DoctorTestimonials />
      <div style={{ margin: "20px 0px 60px 0px" }}>
        <Slogan />
      </div>
      <Footer />
    </main>
  );
}
